import { useState } from "react"
import { FiX } from "react-icons/fi"
import CharacterEditor from "../CharacterEditor"
import Button from "../ui/Button"

export default function CharacterEditorModal({onClose, character, show}) {
    const [newCharacter, setNewCharacter] = useState(character || {
        name: 'New Character',
        description: ''
    })

    return (
        <div className='w-full h-full max-w-[500px] flex flex-col bg-background border-l'>
            <div className='flex justify-between py-2 px-4  items-center'>
                <span className='text-secondary-foreground text-lg font-bold'>Character</span>
                <div className='cursor-pointer text-gray-400 hover:text-white' onClick={() => onClose(null)}><FiX className="w-6 h-6" /></div>
            </div>
            <div className='flex-1 overflow-hidden'>
                <CharacterEditor defaultValue={newCharacter} show={show} onChange={(character) => setNewCharacter(character)} />
            </div>
            <div className='flex justify-end p-4 gap-4'>
                <Button type='danger-ghost' className='min-w-20' onClick={() => onClose(null)}>Cancel</Button>
                <Button type='primary' className='min-w-20' onClick={() => onClose(newCharacter)}>Save</Button>
            </div>
        </div>
    )
}